import httpServer from "../axios";
import {baseUrlt} from "..";

export default {
  // 省
  loginIn(params) {
    return httpServer('post',`${baseUrlt}api/login/index`, params);
  },
  changePassword(params) {
    return httpServer('post',`${baseUrlt}api/user/edit_password`, params);
  },
  tokenLogin(params) {
    return httpServer('post',`${baseUrlt}api/login/tokenLogin`, params);
  },
};